import Stack from '@mui/material/Stack';
import tokens from '@verifime/design-tokens';
import { useEffect, useState } from 'react';
import PortraitDisplay, { TPortraitDisplayProps } from './PortraitDisplay';

export type TIdentityDocumentPortraitProps = {
  fetchIdentityDocumentPortrait?: () => Promise<TPortraitDisplayProps['portraitImageUrl']>;
  dataTestId?: string;
} & Omit<TPortraitDisplayProps, 'portraitImageUrl' | 'unavailableAction' | 'dataTestId'>;

export default function IdentityDocumentPortrait({
  fetchIdentityDocumentPortrait,
  action,
  dataTestId,
  ...portraitProps
}: Readonly<TIdentityDocumentPortraitProps>) {
  const [portraitImageUrl, setPortraitImageUrl] = useState<
    TPortraitDisplayProps['portraitImageUrl'] | undefined
  >(undefined);

  useEffect(() => {
    fetchIdentityDocumentPortrait?.().then(setPortraitImageUrl);
  }, [fetchIdentityDocumentPortrait]);

  return (
    <Stack gap={tokens.spacingXs} padding={tokens.spacingXs} data-testid={dataTestId}>
      <PortraitDisplay
        key={portraitImageUrl}
        portraitImageUrl={portraitImageUrl}
        {...portraitProps}
        // `action` goes in as `unavailableAction` on purpose: it must never render beside a loaded
        // portrait (the footer drawer owns that state). It follows the spread so a caller cannot override it.
        unavailableAction={action}
      />
    </Stack>
  );
}
